<mat-card>{{'cardsOrders' | translate}}</mat-card>

<div class="container" style="padding: 25px;">

  <mat-grid-list cols="6" rowHeight="50px">
    <mat-grid-tile colspan="3">
      <mat-form-field appearance="fill" class="example-form-field">
        <mat-label>{{'enterDateRange' | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker">
          <input matStartDate placeholder="Start date" #fromDate>
          <input matEndDate placeholder="End date" #toDate>
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker>
          <mat-date-range-picker-actions>
            <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
            <button mat-raised-button color="primary" (click)="onApply()" matDateRangePickerApply>{{'filter' |
              translate}}</button>
          </mat-date-range-picker-actions>
        </mat-date-range-picker>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="3">
      &nbsp;
      &nbsp;
      <mat-form-field>
        <mat-label>{{'name' | translate}}</mat-label>
        <input matInput [(ngModel)]="searchByName">
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="6">

      <button mat-raised-button color="primary" (click)="onApply()" style="margin-left: 10px;">
        <mat-icon>search</mat-icon>
        {{'filter' | translate}}
      </button>
      <button mat-raised-button color="primary" [disabled]="reports.length == 0" style="margin-left: 10px;"
        (click)="Print()">
        <mat-icon>print</mat-icon>
        {{'print' | translate}}
      </button>

      <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="exportAsXLSX()">
        <mat-icon>import_export</mat-icon>
        {{'exportExcel' | translate}}
      </button>

    </mat-grid-tile>



  </mat-grid-list>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort id="ordersTable">

      <ng-container matColumnDef="orderId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'orderNo' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.orderId}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.userName}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="userCatg">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'userCatg' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.userCategory}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'category' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.categoryName}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="subCategory">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'subCategory' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.subCategoryName}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.productName}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'quantity' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.quantity}} </td>
        <td mat-footer-cell *matFooterCellDef> {{'total' | translate}} </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'total' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.total}} </td>
        <td mat-footer-cell *matFooterCellDef> {{getTotalCost()}} </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
        <td mat-cell *matCellDef="let row"> {{row.date | date: 'dd/MM/yyyy hh:mm'}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="CardsNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardNo' | translate}} </th>
        <td mat-cell *matCellDef="let row">
          <span *ngFor="let item of row.productCards">
            {{item}}
            <br />
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
      </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>